import React, { useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Divider from "@common/components/Divider/Divider";
import DeviceItem from "../../DeviceItem/DeviceItem";
import { useBreweryModalContext } from "../../hooks/useBreweryModalContext";

export const DeviceSection = ({
  title,
  devices,
  lastUpdate,
  showDivider,
  sortByDeviceType,
  brewEligible,
  nextBrewDate,
  modalActions: modalActionsProp,
}) => {
  // Can consume modal actions from context or via props
  let contextActions = null;
  try {
    const ctx = useBreweryModalContext();
    contextActions = ctx ? ctx.actions : null;
  } catch (e) {
    // Allows standalone rendering in tests without Provider
  }
  const modalActions = modalActionsProp || contextActions || {};

  const sortedDevices = useMemo(() => {
    if (!devices || devices.length === 0) return [];
    if (!sortByDeviceType) return devices;
    return [...devices].sort(
      (a, b) => (a.device_type || 0) - (b.device_type || 0),
    );
  }, [devices, sortByDeviceType]);

  if (!devices || devices.length === 0) {
    return null;
  }

  return (
    <>
      {showDivider && <Divider />}
      <h3 className="brewery__phase">
        {title}{" "}
        {lastUpdate && (
          <span className="brewery__updated">
            Last update: {moment(lastUpdate).fromNow()}
          </span>
        )}
      </h3>
      <div className="row">
        {sortedDevices.map((device) => (
          <div key={device.uuid} className="col-sm-6 col-md-4">
            <DeviceItem
              device={device}
              showModal={modalActions.showModal || modalActions.openBrewModal}
              showWifiModal={
                modalActions.showWifiModal || modalActions.openWifiModal
              }
              showDeviceModal={
                modalActions.showDeviceModal || modalActions.openDeviceModal
              }
              showCleaningModal={
                modalActions.showCleaningModal ||
                modalActions.toggleCleaningModal
              }
              showStopSessionModal={
                modalActions.showStopSessionModal ||
                modalActions.openStopSessionModal
              }
              showResetSessionModal={
                modalActions.showResetSessionModal ||
                modalActions.openResetSessionModal
              }
              showEditFermentationModal={
                modalActions.showEditFermentationModal ||
                modalActions.openEditFermentationModal
              }
              showUnregisterDeviceModal={
                modalActions.showUnregisterDeviceModal ||
                modalActions.openUnregisterDeviceModal
              }
              showAcidSupportModal={
                modalActions.showAcidSupportModal ||
                modalActions.openAcidSupportModal
              }
              brewEligible={brewEligible}
              nextBrewDate={nextBrewDate}
            />
          </div>
        ))}
      </div>
    </>
  );
};

DeviceSection.propTypes = {
  title: PropTypes.string.isRequired,
  devices: PropTypes.array,
  lastUpdate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showDivider: PropTypes.bool,
  sortByDeviceType: PropTypes.bool,
  brewEligible: PropTypes.bool,
  nextBrewDate: PropTypes.string,
  modalActions: PropTypes.object,
};

DeviceSection.defaultProps = {
  devices: [],
  lastUpdate: null,
  showDivider: false,
  sortByDeviceType: false,
  brewEligible: true,
  nextBrewDate: null,
  modalActions: null,
};

export default DeviceSection;
